/* ==========================================================
   PREVIEW ON/OFF TOGGLE
   Makes the CPB "Preview On?" radio buttons behave like
   a single ON/OFF toggle switch.

   The CSS controls the appearance.
   This JavaScript handles switching between the underlying
   CPB "On" and "Off" radio options when the toggle is clicked.
   ========================================================== */

document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.preview-toggle .cpb-radio-group');

  if (!toggle) return;

  e.preventDefault();

  const options = toggle.querySelectorAll('.cpb-radio-button');
  if (options.length < 2) return;

  const onOption = options[0];
  const offOption = options[1];

  const isOn = onOption.getAttribute('aria-checked') === 'true';

  const target = isOn ? offOption : onOption;
  const input = target.querySelector('input[type="radio"]');

  if (input) {
    input.click();
  }
});